import React, { Component } from 'react';
import ReactDOM from "react-dom";
import axios from 'axios';

import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            remind_password: false,
            local_login: false,
            show_password: false,
            show_remember: false,
            remember_me: false,
            user_message: '',
            errors: {}
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.remindPasswordForm = this.remindPasswordForm.bind(this);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {}

    handleInputChange(event) {
        let errors = this.state.errors;

        errors[[event.target.name]] = null;

        this.setState({
            [event.target.name]: event.target.value,
            errors : errors
        })
    }

    handleForgotPassword(event) {
        event.preventDefault();

        this.setState({
            remind_password: !this.state.remind_password
        })
    }

    handleFormSubmit(event) {
        event.preventDefault();

        if (this.state.remind_password) {
            axios
                .post('/xhr/auth/forgot', {
                    email: this.state.email,
                })
                .then(response => {
                    if (response.data.action === 'show_message') {
                        this.setState({
                            user_message: response.data.message,
                        })
                    }
                })
                .catch(error => {

                })
        } else {
            axios
                .post('/xhr/auth/login', {
                    email: this.state.email,
                    password: this.state.password,
                    remember_me: this.state.remember_me
                })
                .then(response => {
                    if (response.data.action === 'password') {
                        this.setState({
                            local_login: true,
                        })
                    }

                    if (response.data.action === 'remember') {
                        this.setState({
                            show_remember: true,
                        })
                    }

                    if (response.data.action === 'redirect') {
                        window.location.href = response.data.url;
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        let errors = this.state.errors;

                        if (error.response.data.errors.password) {
                            errors.email = error.response.data.errors.password;
                            errors.password = error.response.data.errors.password;
                        }

                        this.setState({
                            errors: errors
                        })
                    }
                })
        }

    }

    remindPasswordForm() {
        if (this.state.user_message) return null;

        const { remind_password, email, errors } = this.state;

        if (!remind_password) return null;

        return (
            <form onSubmit={this.handleFormSubmit} autoComplete='off'>
                <h2>Priminti slaptažodį</h2>
                <TextField style={{width: '340px'}} type='email' label="Email" name='email'
                           onChange={this.handleInputChange} value={email}
                           error={!!(errors.email)} helperText={errors.email} />

                <div style={{marginTop: '20px'}}>
                    <Button type="submit" className='reg-btn text-uppercase' style={{marginRight: '20px'}} variant="contained" color="primary" disableElevation>Priminti</Button>
                </div>

                <div style={{marginTop: '25px'}}>
                    <a href="/xhr/auth/register">Register</a> / <a href="" onClick={this.handleForgotPassword}>Prisijungti</a>
                </div>
            </form>
        )
    }

    loginForm() {
        if (this.state.user_message) return null;

        const {remind_password, email, password, show_password, local_login, show_remember, errors} = this.state;

        if (remind_password) return null;

        return (
            <form onSubmit={this.handleFormSubmit} autoComplete='off'>
                {
                    (show_remember) ? (
                        <React.Fragment>
                            <h2>Prisiminti mane</h2>
                            <div style={{marginTop: '20px'}}>
                                <Button type="submit" style={{marginRight: '20px'}} variant="contained" color="primary" disableElevation onClick={() => this.setState({remember_me: true})}>yes</Button>
                                <Button type="submit" variant="contained" color="secondary" disableElevation>no</Button>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <h2>Prisijungti prie sistemos</h2>

                            <TextField style={{width: '340px'}} type='email' label="Email" name='email'
                                       onChange={this.handleInputChange} value={email}
                                       error={!!(errors.email)} helperText={errors.email} />

                            {(local_login) && (
                                <FormControl style={{width: '340px', marginTop: '15px'}} error={!!(errors.password)}>
                                    <InputLabel htmlFor="password">Password</InputLabel>
                                    <Input autoFocus={true}
                                           id='password'
                                           type={show_password ? 'text' : 'password'}
                                           name='password'
                                           value={password}
                                           onChange={this.handleInputChange}
                                           endAdornment={
                                               <InputAdornment position="end">
                                                   <IconButton aria-label="toggle password visibility"
                                                               onClick={() => this.setState({show_password: !show_password})}>
                                                       {show_password ? <Visibility/> : <VisibilityOff/>}
                                                   </IconButton>
                                               </InputAdornment>
                                           }/>
                                    {errors.password && (
                                        <FormHelperText>{errors.password}</FormHelperText>
                                    )}
                                </FormControl>
                            )}

                            <div style={{marginTop: '20px'}}>
                                <Button type="submit" className='reg-btn text-uppercase' style={{marginRight: '20px'}} variant="contained" color="primary" disableElevation>next</Button>
                            </div>
                        </React.Fragment>
                    )
                }
                <div style={{marginTop: '25px'}}>
                    <a href="/xhr/auth/register">Registruotis</a> / <a href="" onClick={this.handleForgotPassword}>Pamiršau slaptažodį</a>
                </div>
            </form>
        );
    }

    renderUserMessage() {
        if (!this.state.user_message) return null;

        return (
            <React.Fragment>
                <h2 style={{marginBottom: '35px'}}>{this.state.user_message}</h2>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="login-box" style={{width: '400px'}}>
                { this.remindPasswordForm() }
                { this.loginForm() }
                { this.renderUserMessage() }
            </div>
        )
    }
}

ReactDOM.render(<Login />, document.getElementById("auth"));